export default __webpack_public_path__ + "static/media/4.c1cf68c7.png";